module.exports = __webpack_public_path__ + "img/gzgzcwlfqjd.775dc5f1.png";